module.exports = __webpack_public_path__ + "files/b3534c191114b604e4134b725cac9775.png";